/**
 * Statuszeile, solange eine Nachricht mit Anhängen unterwegs ist. Bis v1.375.0 hieß es immer
 * „Bilder werden analysiert…" — auch bei einer JSON-Liste, die KIAN nur liest.
 */

type AttachmentKind = 'image' | 'pdf' | 'file';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.heic', '.heif'];

function kindOf(file: File): AttachmentKind {
  const name = file.name.toLowerCase();
  if (file.type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  // HEIC kommt je nach System ohne MIME-Typ — dann entscheidet die Endung
  if (file.type.startsWith('image/') || IMAGE_EXTENSIONS.some((ext) => name.endsWith(ext))) return 'image';
  return 'file';
}

export function attachmentStatusLabel(files: readonly File[]): string {
  const kinds = new Set(files.map(kindOf));
  if (kinds.size !== 1) return 'Anhänge werden verarbeitet…';
  const one = files.length === 1;
  switch ([...kinds][0]) {
    case 'image':
      return one ? 'Bild wird analysiert…' : 'Bilder werden analysiert…';
    case 'pdf':
      return one ? 'PDF wird gelesen…' : 'PDFs werden gelesen…';
    default:
      return one ? 'Datei wird gelesen…' : 'Dateien werden gelesen…';
  }
}
